// src/pages/user/components/stats/Stats.tsx
import React from 'react'
import classes from './Stats.module.sass'
import { ExecutorClusterResponse } from '../../../../../../common/types/interfaces'

type Props = {
  cluster: ExecutorClusterResponse | null
}

export const Stats: React.FC<Props> = ({ cluster }) => {
  if (!cluster) return null

  return (
    <div className={classes.container}>
      <div className={classes.title}>Статистика</div>
      <div className={classes.content}>
        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>Кластер</div>
            <div className={classes.value}>{cluster.cluster.name}</div>
          </div>
        </div>
        <div className={classes.empty}>Статистика скоро появится</div>
      </div>
    </div>
  )
}
